const TEAMMATE_CAPACITIES_BY_VIEWER: Record<number, number[]> = {
  0: [],
  1: [3],
  2: [2, 3],
  3: [1, 2, 3],
};

/** Candidate capacities whose current teams can merge with the viewer's. */
export const getAutosuggestTeammateCapacities = (
  viewerTeammatesNeeded: number
): number[] => TEAMMATE_CAPACITIES_BY_VIEWER[viewerTeammatesNeeded] ?? [];
